
:host {
  color: var(--default-color-text-primary);
  font-family: var(--type-sans);
  font-weight: var( --type-weight-light);
  font-size: var(--default-type-scale-14);
  height: 100%;
  width: 100%;
} 

.row {
  border-bottom: .5px solid var(--default-color-border-layer-primary);
  padding: .5rem 1rem;
  cursor: pointer;
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1fr 0.7fr;
  align-items: center;
  column-gap: var(--spacing-07);
  background-color: #f5f5f4;
  height: 2rem;
}

.column {
  overflow: hidden;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.identity {
  display: flex;
  align-items: center;
  gap: var(--default-spacing-05);
  width: 99%;
}

.name, .email {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.cell-container {
  width: 100%;
}

.actions {
  display: flex;
  flex-direction: row-reverse;
  gap: 8px;
}

.row:hover {
  background-color:  var(--default-color-field-primary-hover)
}

.container {
  display: flex;
  flex-direction: column;
}
